<ion-header class="map-header">
    <ion-toolbar>

        <ion-title mode="ios" role="heading" *ngIf="data && data.isLongDistance">{{ 'MAP_REGION_TITLE' | translate }}</ion-title>
        <ion-title mode="ios" role="heading" *ngIf="data && !data.isLongDistance">{{ data.timeDisplay }}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>

    <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        SEGMENTS FOR VIEW TYPE
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <ion-toolbar mode="ios" class="search-type-toolbar">
        <ion-segment mode="ios" #tabs id="tabs" [(ngModel)]="mapTab">
            <ion-segment-button (click)="showOverview()" value="overview">
                <ion-label [innerHTML]="'MAP_VIEW_OVERVIEW' | translate"></ion-label>
            </ion-segment-button>
            <ion-segment-button (click)="showStart()" value="start">
                <ion-label [innerHTML]="'MAP_VIEW_START' | translate"></ion-label>
            </ion-segment-button>
            <ion-segment-button (click)="showStop()" value="stop">
                <ion-label [innerHTML]="'MAP_VIEW_STOP' | translate"></ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-toolbar>

</ion-header>

<ion-content>
    <div #map id="map">
        <!-- <page-map-type *ngIf="mapLoaded"></page-map-type> -->
        <div class="map-spinner" *ngIf="!mapLoaded"><ion-spinner ></ion-spinner></div>
    </div>
</ion-content>